"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Icon = require("./Icon.styles");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Icon = function Icon(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'arrowBack' : _ref$name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      action = _ref.action,
      _ref$isClickable = _ref.isClickable,
      isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? false : _ref$isInline,
      dataTestId = _ref.dataTestId;
  var icon = _constants.iconsMap[name];
  var mappedSize = (0, _helpers.mapSize)(size);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Icon.Occ__IconContainer, {
    color: color,
    isClickable: isClickable,
    isInline: isInline,
    onClick: action,
    "data-test-id": dataTestId ? dataTestId : "occ-icon-".concat(name)
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: icon.viewBox,
    width: mappedSize,
    height: mappedSize
  }, icon.svg)));
};

var _default = Icon;
exports["default"] = _default;